import { AlertDto } from '@/Domain/api/Conversation/dto/Alert.dto';
import { AlertFormItem } from '@/Domain/components/Insights/Alerts/AlertForm/AlertFormItem';
import { Form } from '@/Domain/components/Shared/Form/Form';
import { useAlertForm } from '@/Domain/hooks/AI/useAlertForm/useAlertForm.hook';

type Props = {
  index: number;
  alert: AlertDto;
};

export const AlertForm = ({ index, alert }: Props) => {
  const {
    form,
    handleSubmit,
    handleDelete,
    handleReset,
    handleToggleActive,
    setIsEditMode,
    isEditMode,
    isUpdatePending,
  } = useAlertForm(alert);

  return (
    <Form {...form}>
      <form
        onSubmit={form.handleSubmit(handleSubmit)}
        className="col-span-full my-2 grid min-w-0 rounded-xl border border-border p-4 @5xl:grid-cols-subgrid @5xl:border-0 @5xl:p-0"
      >
        <AlertFormItem
          index={index}
          form={form}
          alert={alert}
          isEditMode={isEditMode}
          isUpdatePending={isUpdatePending}
          setIsEditMode={setIsEditMode}
          onDelete={handleDelete}
          onReset={handleReset}
          onToggleActive={handleToggleActive}
        />
      </form>
    </Form>
  );
};
